import { createContext, useContext } from 'react';

export interface SidebarContextValue {
  expanded: boolean;
}

export const SidebarContext = createContext<SidebarContextValue>({
  expanded: true,
});

export const useSidebarExpanded = () => useContext(SidebarContext).expanded;
